import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";

import TableBody from "./components/TableBody";
import TableHeader from "./components/TableHeaeder";
import { ContainerWithLoader, PaginationWithLimit } from "../../components/ui";
import AccountsFilterAutocomplete from "./components/AccountsFilterAutocomplete";

import { ContainerBg, StyledTable } from "../../useGeneralStyles";
import { rithmicAccountsActions } from "../../reducers/rithmicAccounts";
import { APIRithmic } from "../../api";
import { useRithmicAccountsContext } from "../../context";

import { setPage } from "../../utils";

const RithmicAccounts = (): React.ReactElement => {
  const dispatch = useDispatch();
  const {
    page,
    setPage: setPageContext,
    sortBy,
    setLimit,
    limit,
    search,
  } = useRithmicAccountsContext();

  const { e2tAccounts, count, loading } = useSelector((state) => state.rithmicAccounts.data);

  const handleSetPage = (value: number) => setPage(value, count, +limit, setPageContext);

  useEffect(() => {
    const controller = new AbortController();
    const { signal } = controller;

    (async () => {
      try {
        dispatch(rithmicAccountsActions.fetchAccountsRequest());
        const data = { limit, page, sortBy, contains: search };
        const response = await APIRithmic.getRithmicAccountsData(data, signal);
        dispatch(rithmicAccountsActions.fetchAccountsSuccess(response.data));
      } catch (error) {
        console.error("Error fetching rithmic accounts");
        dispatch(rithmicAccountsActions.fetchAccountsFailed());
      }
    })();
    return () => controller.abort();
  }, [search, limit, page, sortBy]);

  return (
    <ContainerBg>
      <AccountsFilterAutocomplete />
      <div>
        <p>
          Users found:<b>{count}</b>
        </p>
      </div>

      <ContainerWithLoader
        isLoading={loading}
        report={e2tAccounts}
        noResultsMessage="There are no results"
      >
        <StyledTable tableWithoutHover>
          <TableHeader />
          <TableBody />
        </StyledTable>
      </ContainerWithLoader>

      <div>
        <PaginationWithLimit
          count={count}
          limit={limit}
          page={page}
          setPageState={handleSetPage}
          setLimit={setLimit}
        />
      </div>
    </ContainerBg>
  );
};

export default RithmicAccounts;
